import HomePage from "../HomePage";
import TaskTabs from "./TaskTabs";
import { RitualIcon } from "../../../Components/LandingHeader/Feedback/icons/Icons";

const PlanYourDayWithoutAI = () => {
    return (
        <div className="plan-your-day-container self-stretch flex flex-col gap-5 w-full max-w-[1800px]">
            <div className="self-stretch inline-flex justify-start items-center gap-2.5">
                <RitualIcon />
                <div className="flex justify-center text-2xl font-normal font-['RL_Madena'] dark-primary-color-60">Morning Ritual</div>
                <div className="self-stretch justify-center text-2xl font-normal font-['RL_Madena'] dark-primary-color-20">Plan Your Day</div>
            </div>
            <div className="self-stretch inline-flex justify-start items-start gap-14">
                <TaskTabs />
                <div className="w-0 self-stretch origin-top-left opacity-10 outline outline-1 outline-offset-[-0.50px] outline-black/50 dark:outline-white/50"></div>
                <div className="flex-1 self-stretch inline-flex flex-col justify-start items-start gap-10">
                    <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                        <div className="self-stretch justify-center text-4xl font-normal font-['RL_Madena'] dark-primary-color-20">Today’s tasks</div>
                        <div className="self-stretch justify-center text-base font-normal font-['Inter'] leading-normal dark-primary-color-60">Keep it light. Focus on what really matters.</div>
                    </div>
                    <div className="self-stretch rounded-3xl outline outline-1 outline-offset-[-0.50px] outline-white/5 flex flex-col justify-start items-start">
                        <div className="self-stretch rounded-3xl outline outline-1 outline-offset-[-0.50px] outline-black/5 dark:outline-white/5 flex flex-col justify-start items-start gap-5">
                            <div className="self-stretch flex flex-col justify-start items-center">
                                <HomePage journalSection={false} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlanYourDayWithoutAI;